if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

        const btnShowModalScheduleAppointmentPickup = document.querySelectorAll('.btn-show-modal-schedule-appointment-from-pickup');
        const textShowModalScheduleAppointmentPickup = document.querySelectorAll('.text-show-modal-schedule-appointment-from-pickup');
        const mainContainerPagesFromScheduleAppointmentPickup = document.getElementById('main-container-pages');
        const modalScheduleAppointmentFromPickup = document.getElementById('modal-schedule-appointment');
        const descriptionScheduleAppointmentFromPickup = document.getElementById('text-description-schedule-appointment');
        const titleScheduleAppointmentFromPickup = document.getElementById('title-schedule-appointment');
        const variantCurrentSelectedFromPickup = document.getElementById('value-variant');
        const infoProduct = document.getElementById('info-product-schedule-appointment');
        const backModalPickup = document.getElementById('back-modal-schedule-appointment');   
        const modalPickup = document.getElementById('pickup-availability-drawer');


        btnShowModalScheduleAppointmentPickup?.forEach( element => {
          element.addEventListener("click", (e) => {
            const button = e.target.closest("button");

            if (button){

              const observerFormScheduleAppointmentFromPickup = new MutationObserver((mutations, obs) => {
                const formulario = document.querySelector(document.getElementById('pickup-availability')?.dataset.idFormScheduleAppointment);
                if (formulario) {
                  obs.disconnect();
        
                  formulario.contentWindow.postMessage({
                     sku: variantCurrentSelectedFromPickup.dataset.skuVariant,
                     boutique: button?.dataset.storeAvailability
                  }, "*");
        
                }
              });

              observerFormScheduleAppointmentFromPickup.observe(document.body, {
                childList: true,
                subtree: true,
              });

              document.querySelector('pickup-availability-drawer').hide();
              descriptionScheduleAppointmentFromPickup.innerHTML = document.getElementById('pickup-availability')?.dataset.textDescriptionScheduleAppointment;
              titleScheduleAppointmentFromPickup.innerHTML = document.getElementById('pickup-availability')?.dataset.titleScheduleAppointment;
              mainContainerPagesFromScheduleAppointmentPickup.classList.add("overflow-hidden");
              modalScheduleAppointmentFromPickup?.classList.remove("display-none");
              infoProduct.classList.remove("display-none");
              backModalPickup.classList.remove("display-none");
              infoProduct.innerHTML = `
                <div class="width-percentage-40 flex align-items-center margin-top-15-px ">
                    <img class="width-110-px" src="${variantCurrentSelectedFromPickup.dataset.productImage}" alt="${variantCurrentSelectedFromPickup.dataset.titleProduct}"/>
                </div>
                <div class="flex flex-direction-column width-percentage-50 margin-bottom ">
                    <p class="font-size-12-px font-weight-600 text-gray-30 margin-bottom-5-px margin-top-none text-transform-uppercase">${variantCurrentSelectedFromPickup.dataset.titleProduct}</p>
                    <p class="font-size-12-px font-weight-400 text-gray-30 margin-bottom-20-px margin-top-none">${variantCurrentSelectedFromPickup.dataset.title}</p>
                    <p class="font-size-16-px font-weight-300 text-gray-30 margin-bottom-none margin-top-none text-align-right">${variantCurrentSelectedFromPickup.dataset.priceVariant}</p>
                </div>
              `;
            }
          })
        })

        textShowModalScheduleAppointmentPickup?.forEach( element => {
          element.addEventListener("click", (e) => {
            const textPickup = e.target.closest("p");

            console.log(textPickup?.dataset.storeAvailability);

            if (textPickup){

              const observerFormScheduleAppointmentFromPickup = new MutationObserver((mutations, obs) => {
                const formulario = document.querySelector(document.getElementById('pickup-availability')?.dataset.idFormScheduleAppointment);
                if (formulario) {
                  obs.disconnect();
        
                  formulario.contentWindow.postMessage({
                     sku: variantCurrentSelectedFromPickup.dataset.skuVariant,
                     boutique: textPickup?.dataset.storeAvailability
                  }, "*");
        
                }
              });

              observerFormScheduleAppointmentFromPickup.observe(document.body, {
                childList: true,
                subtree: true,
              });

              document.querySelector('pickup-availability-drawer').hide();
              descriptionScheduleAppointmentFromPickup.innerHTML = document.getElementById('pickup-availability')?.dataset.textDescriptionScheduleAppointment;
              titleScheduleAppointmentFromPickup.innerHTML = document.getElementById('pickup-availability')?.dataset.titleScheduleAppointment;
              mainContainerPagesFromScheduleAppointmentPickup.classList.add("overflow-hidden");
              modalScheduleAppointmentFromPickup?.classList.remove("display-none");
              infoProduct.classList.remove("display-none");
              backModalPickup.classList.remove("display-none");
              infoProduct.innerHTML = `
                <div class="width-percentage-40 flex align-items-center margin-top-15-px ">
                    <img class="width-110-px" src="${variantCurrentSelectedFromPickup.dataset.productImage}" alt="${variantCurrentSelectedFromPickup.dataset.titleProduct}"/>
                </div>
                <div class="flex flex-direction-column width-percentage-50 margin-bottom ">
                    <p class="font-size-12-px font-weight-600 text-gray-30 margin-bottom-5-px margin-top-none text-transform-uppercase">${variantCurrentSelectedFromPickup.dataset.titleProduct}</p>
                    <p class="font-size-12-px font-weight-400 text-gray-30 margin-bottom-20-px margin-top-none">${variantCurrentSelectedFromPickup.dataset.title}</p>
                    <p class="font-size-16-px font-weight-300 text-gray-30 margin-bottom-none margin-top-none text-align-right">${variantCurrentSelectedFromPickup.dataset.priceVariant}</p>
                </div>
              `;
            }
          })
        })

        backModalPickup?.addEventListener("click", (e) => {
          mainContainerPagesFromScheduleAppointmentPickup.classList.remove("overflow-hidden");
          modalScheduleAppointmentFromPickup?.classList.add("display-none");
          infoProduct.classList.add("display-none");
          backModalPickup.classList.add("display-none");

          modalPickup.setAttribute('open', '');
          document.body.classList.add('overflow-hidden');
        })

        const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
        colorClassesToApply.forEach((colorClass) => {
          document.querySelector('pickup-availability-drawer').classList.add(colorClass);
        });

        const button = this.querySelector('button');
        if (button)
          button.addEventListener('click', (evt) => {
            console.log(evt);
            document.querySelector('pickup-availability-drawer').show(evt.target);
          });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}
